import React, { useEffect } from 'react';
import { X, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { createPortal } from 'react-dom';

export default function ReferentielForm({ activeTab, formData, setFormData, onSubmit, onClose, saving, structure, tabs }) {
  const currentTabLabel = tabs.find(t => t.id === activeTab)?.label;
  const doms = structure || [];
  const selectedDom = doms.find(d => String(d.id) === String(formData.domaine_id));
  const subdoms = selectedDom?.subdomains || [];

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, []);

  const modal = (
    <div className="admin-modal-overlay">
      <motion.form
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        onSubmit={onSubmit}
        className="admin-modal-form"
      >
        <div className="admin-modal-header">
          <h2 className="titre-carte">
            {formData.id ? 'Modifier' : 'Nouveau'} {currentTabLabel}
          </h2>
          <button type="button" onClick={onClose} className="act act-icone act-tertiaire"><X className="w-5 h-5 text-[var(--text-muted)]" /></button>
        </div>
        
        <div className="admin-modal-content space-y-5">
          {activeTab !== 'domaines' && (
            <div className="space-y-1.5">
              <label>Domaine parent</label>
              <select
                required
                className="champ"
                value={formData.domaine_id}
                onChange={e => setFormData({ ...formData, domaine_id: e.target.value, sous_domaine_id: '' })}
              >
                <option value="">Choisir un domaine...</option>
                {doms.map(d => <option key={d.id} value={d.id}>{d.nom}</option>)}
              </select>
            </div>
          )}

          {activeTab === 'questions' && (
            <div className="space-y-1.5">
              <label>Axe stratégique (sous-domaine)</label>
              <select
                required
                className="champ"
                value={formData.sous_domaine_id}
                onChange={e => setFormData({ ...formData, sous_domaine_id: e.target.value })}
              >
                <option value="">Choisir l'axe...</option>
                {subdoms.map(s => (
                  <option key={s.id} value={s.id}>{s.nom}</option>
                ))}
              </select>
            </div>
          )}

          {activeTab !== 'questions' && (
            <div className="space-y-1.5">
              <label>Nom de l'élément</label>
              <input
                required
                placeholder="Ex. Gouvernance de projet"
                className="champ"
                value={formData.nom}
                onChange={e => setFormData({ ...formData, nom: e.target.value })}
              />
            </div>
          )}

          {activeTab === 'subdomains' && (
            <div className="space-y-1.5">
              <label>Description (optionnel)</label>
              <textarea
                className="champ"
                rows={2}
                placeholder="Précisez l'objectif de cet axe..."
                value={formData.description}
                onChange={e => setFormData({ ...formData, description: e.target.value })}
              />
            </div>
          )}

          {activeTab === 'questions' && (
            <>
              <div className="space-y-1.5">
                <label>Libellé de la question</label>
                <textarea
                  required
                  placeholder="Posez votre question ici..."
                  className="champ font-bold"
                  rows={3}
                  value={formData.texte}
                  onChange={e => setFormData({ ...formData, texte: e.target.value })}
                />
              </div>
              <div className="space-y-3 pt-3 border-t border-[var(--border)]">
                <label className="mb-2 block">Grille d'évaluation (1 à 5 pts)</label>
                {formData.reponses.map((rep, idx) => (
                  <div key={idx} className="flex gap-2 items-center">
                    <div className="w-8 h-8 rounded-pastille bg-[var(--accent)]/10 flex items-center justify-center border border-[var(--accent)]/20 shrink-0">
                      <span className="text-[10px] font-black text-[var(--accent-texte)]">{rep.points}</span>
                    </div>
                    <input
                      required
                      className="champ flex-1 !py-2 !text-xs"
                      placeholder={`Réponse pour ${rep.points} pts`}
                      value={rep.label}
                      onChange={e => {
                        const next = [...formData.reponses];
                        next[idx] = { ...next[idx], label: e.target.value };
                        setFormData({ ...formData, reponses: next });
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="admin-modal-footer">
          <button type="button" onClick={onClose} className="act act-tertiaire flex-1">Annuler</button>
          <button type="submit" disabled={saving} aria-busy={saving || undefined} className="act flex-[1.5]">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Enregistrer
          </button>
        </div>
      </motion.form>
    </div>
  );

  return createPortal(modal, document.body);
}
